import styled from 'styled-components';
import Icon from '../../assets/images/circle-info-30-yellow.svg';

const CircleInfoIconYellow = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 30px 30px;
  display: block;
  position: relative;
  width: 30px;
  height: 30px;
`;

export default CircleInfoIconYellow;
